export default "__VITE_ASSET__CpiwowJk__"